var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("span", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("Tool.MyInfo")))
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "personal-form",
              attrs: {
                model: _vm.form,
                disabled: !_vm.isEdit,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Tool.CNName"), prop: "chineseName" }
                },
                [
                  _c("el-input", {
                    attrs: { size: "small", disabled: "" },
                    model: {
                      value: _vm.form.chineseName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "chineseName", $$v)
                      },
                      expression: "form.chineseName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Tool.ENName"), prop: "englishName" }
                },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.form.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "englishName", $$v)
                      },
                      expression: "form.englishName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.Phone"), prop: "userPhone" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.cell,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cell", $$v)
                      },
                      expression: "form.cell"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.Tel"), prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.form.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "FAX：", prop: "fax" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.form.fax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fax", $$v)
                      },
                      expression: "form.fax"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.Email"), prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", disabled: "" },
                    model: {
                      value: _vm.form.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.QQ"), prop: "qq" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.form.qq,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "qq", $$v)
                      },
                      expression: "form.qq"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "personal-footer" },
            [
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.isEdit = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Tool.Edit")))]
                  )
                : _vm._e(),
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modifyPasswordDialogVisible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Tool.ChangePsd")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("Tool.Save")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.cancelEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("Tool.Cancel")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modifyPasswordDialogVisible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Tool.ChangePsd")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("modify-password-dialog", {
            attrs: { visible: _vm.modifyPasswordDialogVisible },
            on: {
              "update:visible": function($event) {
                _vm.modifyPasswordDialogVisible = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-top": "15px" } },
        [
          _c("span", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("Tool.PersonalEmailSettings")))
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "personal-form",
              attrs: { model: _vm.emailSettings, "label-width": "130px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tool.Email") } },
                [
                  _c("el-input", {
                    attrs: { size: "small", disabled: "" },
                    model: {
                      value: _vm.emailSettings.authSender,
                      callback: function($$v) {
                        _vm.$set(_vm.emailSettings, "authSender", $$v)
                      },
                      expression: "emailSettings.authSender"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    attrs: {
                      slot: "label",
                      label: _vm.$t("Tool.EmailPassword")
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "show-password": "",
                      size: "small",
                      disabled: _vm.editControl
                    },
                    model: {
                      value: _vm.emailSettings.authSenderPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.emailSettings, "authSenderPwd", $$v)
                      },
                      expression: "emailSettings.authSenderPwd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.SenderServer") } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.editControl },
                    model: {
                      value: _vm.emailSettings.smtpHost,
                      callback: function($$v) {
                        _vm.$set(_vm.emailSettings, "smtpHost", $$v)
                      },
                      expression: "emailSettings.smtpHost"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.Port") } },
                [
                  _c("el-input", {
                    attrs: {
                      value:
                        _vm.emailSettings.smtpPort === 0
                          ? ""
                          : _vm.emailSettings.smtpPort,
                      disabled: _vm.editControl
                    },
                    on: { input: _vm.onSmtpPortInput }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Tool.SignatureSetup"), prop: "sign" }
                },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editControl,
                        expression: "editControl"
                      }
                    ],
                    staticClass: "mask"
                  }),
                  _c("quill-editor", {
                    ref: "myQuillEditor",
                    attrs: { options: _vm.editorOption },
                    on: {
                      change: function($event) {
                        return _vm.onEditorChange($event)
                      }
                    },
                    model: {
                      value: _vm.emailSettings.sign,
                      callback: function($$v) {
                        _vm.$set(_vm.emailSettings, "sign", $$v)
                      },
                      expression: "emailSettings.sign"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "110px" },
                  attrs: { "true-label": 1, "false-label": 0 },
                  model: {
                    value: _vm.signature,
                    callback: function($$v) {
                      _vm.signature = $$v
                    },
                    expression: "signature"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.ToEnableTheSignature")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "50px" },
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.editControl
                  },
                  model: {
                    value: _vm.emailSettings.smtpSsl,
                    callback: function($$v) {
                      _vm.$set(_vm.emailSettings, "smtpSsl", $$v)
                    },
                    expression: "emailSettings.smtpSsl"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.UseSsl")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "personal-footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editControl,
                      expression: "editControl"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.emailEditor }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Edit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editControl,
                      expression: "!editControl"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.emailSave }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Save")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editControl,
                      expression: "!editControl"
                    }
                  ],
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.cancelPersonalEditing }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sendTest } },
                [_vm._v(_vm._s(_vm.$t("Tool.SendTest")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card authorization",
          staticStyle: { "margin-top": "15px" }
        },
        [
          _c("span", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("Message.CurrentPersonalAuthorizationList")))
          ]),
          _c("cargo-ag-grid", {
            staticStyle: { height: "200px" },
            attrs: {
              "grid-options": _vm.individual.gridOptions,
              "column-defs": _vm.individual.columnDefs,
              "show-side-bar": false,
              "row-data": _vm.individual.rowData
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showUserConfig,
              expression: "showUserConfig"
            }
          ],
          staticClass: "box-card authorization",
          staticStyle: { "margin-top": "15px" }
        },
        [
          _c("span", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PushNodeSettings")))
          ]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_WarningSwitch") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: !_vm.isEditDataService },
                      model: {
                        value: _vm.dataServiceForm.open,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "open", $$v)
                        },
                        expression: "dataServiceForm.open"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartAlert")))
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CloseAlert")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ConfigurationAlert"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_DocumentNotification")
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isOtherFieldsDisabled },
                      model: {
                        value: _vm.dataServiceForm.notifyJobType,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "notifyJobType", $$v)
                        },
                        expression: "dataServiceForm.notifyJobType"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { label: 0 }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_NoticeOfEachBill"))
                          )
                        ]
                      ),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_NoNoticeOfTickets"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_WarningConditions") }
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticStyle: { width: "405px" },
                      attrs: { disabled: _vm.isOtherFieldsDisabled },
                      model: {
                        value: _vm.dataServiceForm.ruleItem,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "ruleItem", $$v)
                        },
                        expression: "dataServiceForm.ruleItem"
                      }
                    },
                    _vm._l(_vm.warningTypes, function(item, index) {
                      return _c(
                        "el-checkbox",
                        { key: index, attrs: { label: item.code } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isZh ? item.chineseName : item.englishName
                            )
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Message.PortOfDepartureUpdate") } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticStyle: { width: "405px" },
                      attrs: { disabled: _vm.isOtherFieldsDisabled },
                      model: {
                        value: _vm.dataServiceForm.ruleItem,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "ruleItem", $$v)
                        },
                        expression: "dataServiceForm.ruleItem"
                      }
                    },
                    [
                      _vm._l(_vm.portAreaReminder, function(item, index) {
                        return _c(
                          "el-checkbox",
                          { key: index, attrs: { label: item.code } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isZh ? item.chineseName : item.englishName
                              )
                            )
                          ]
                        )
                      }),
                      _c("br"),
                      _vm._l(_vm.nodeAlertTypes, function(item, index) {
                        return _c(
                          "el-checkbox",
                          { key: index + 1, attrs: { label: item.code } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isZh ? item.chineseName : item.englishName
                              )
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Message.DestinationPortUpdate") } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      staticStyle: { width: "405px" },
                      attrs: { disabled: _vm.isOtherFieldsDisabled },
                      model: {
                        value: _vm.dataServiceForm.ruleItem,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "ruleItem", $$v)
                        },
                        expression: "dataServiceForm.ruleItem"
                      }
                    },
                    _vm._l(_vm.DestinationPortNodeAlertTypes, function(
                      item,
                      index
                    ) {
                      return _c(
                        "el-checkbox",
                        { key: index, attrs: { label: item.code } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isZh ? item.chineseName : item.englishName
                            )
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_ReminderMethod") } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.isOtherFieldsDisabled
                      },
                      model: {
                        value: _vm.dataServiceForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "email", $$v)
                        },
                        expression: "dataServiceForm.email"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Email2")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.isOtherFieldsDisabled
                      },
                      model: {
                        value: _vm.dataServiceForm.weChat,
                        callback: function($$v) {
                          _vm.$set(_vm.dataServiceForm, "weChat", $$v)
                        },
                        expression: "dataServiceForm.weChat"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Wechat")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "warm-prompt-item",
                  attrs: {
                    label: _vm.$t(
                      "BusinessIntelligence.businessIntelligenceChart.warmPrompt"
                    )
                  }
                },
                [
                  _c("div", { staticStyle: { width: "380px" } }, [
                    _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_DataServiceReminderWarning1")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_DataServiceReminderWarning2")
                        )
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "personal-footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEditDataService,
                      expression: "!isEditDataService"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.isEditDataService = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Edit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditDataService,
                      expression: "isEditDataService"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.saveDataService }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Save")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditDataService,
                      expression: "isEditDataService"
                    }
                  ],
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.cancelDataService }
                },
                [_vm._v(_vm._s(_vm.$t("Tool.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.authorizationVisible,
            title: _vm.title,
            width: "500px",
            "append-to-body": true
          },
          on: {
            close: function($event) {
              _vm.authorizationVisible = false
            }
          }
        },
        [_c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.secondaryConfirmation,
            "append-to-body": "",
            "close-on-click-modal": false,
            title: _vm.$t("Message.SendTest"),
            width: "350px"
          },
          on: {
            "update:visible": function($event) {
              _vm.secondaryConfirmation = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                isplay: "flex",
                "align-items": "center",
                "justify-content": "center"
              }
            },
            [
              _c(
                "el-row",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 6 }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.SendTo")))]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.sendTestVal,
                          callback: function($$v) {
                            _vm.sendTestVal = $$v
                          },
                          expression: "sendTestVal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.againDetermine }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Confirm2")))]
              ),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.confirmAgain } },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("we-chat-auth-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.weChatVisible,
            expression: "weChatVisible"
          }
        ],
        attrs: { visible: _vm.weChatVisible, data: _vm.openData },
        on: {
          close: function($event) {
            _vm.weChatVisible = false
          },
          change: _vm.changeWeChatAuth
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }